export default {
    title: "ตั้งค่าความเป็นส่วนตัว",
    mkt: "ตั้งค่าการแจ้งเตือน",
    copy_Data: "ขอรับสำเนาข้อมูลส่วนบุคคล",
    tranfer_data: "ส่งสำเนาข้อมูลส่วนบุคคลให้ผู้อื่น",
    save_success_title: "บันทึกข้อมูลการรับข่าวสารสำเร็จ",
    save_success_msg: "คุณได้ทำการบันทึกการตั้งค่าข้อมูล </br> การรับข่าวสารเรียบร้อยแล้ว",

    mkt_setting: {
        title: "ความยินยอมเพื่อวัตถุประสงค์<br />ทางการตลาด",
    },
    copydata: {
        title: "ขอรับสำเนาข้อมูลส่วนบุคคล",
        name: "ชื่อ",
        lastname: "นามสกุล",
        birthdate: "วันเกิด",
        phone: "เบอร์โทรศัพท์",
        age: "อายุ",
        age_detail: "ฉันมีอายุเกิน 20 ปีบริบูรณ์",
        email_label: "กรอกอีเมลสำหรับรับข้อมูล",
        email: {
            name: 'กรอกอีเมลสำหรับรับข้อมูล',
            placeholder: '',
            required: 'กรุณาระบุอีเมล',
            too_short: '',
            invalid: 'รูปแบบอีเมลไม่ถูกต้อง',
        },
        password_label: "กำหนดรหัสผ่านในการเปิดไฟล์",
        confirm_export: "ยืนยันการขอรับสำเนาข้อมูลส่วนบุคคล",
        export_success_title: "ขอรับข้อมูลส่วนบุคคลสำเร็จ",
        export_success_detail: "ทำรายการการขอข้อมูลส่วนบุคคลสำเร็จ ระบบ </br> ได้จัดส่งข้อมูลส่วนบุคคลไปยังอีเมลเรียบร้อยแล้ว",
    },
    transferdata_title: 'ส่งสำเนาข้อมูลส่วนบุคคลให้ผู้อื่น',
    contact_callcenter: 'หากมีข้อสงสัย กรุณาติดต่อเบอร์',
    contact_phone: '02-6451212',
}
